import axios from "axios";
import api from "../utils/axiosInterceptor";
const API_URL = process.env.REACT_APP_API_URL;

// export const UpdateSignupService = async (data) => {
// 	try {
// 		const config = {
// 			headers: {
// 				"Content-Type": data instanceof FormData ? "multipart/form-data" : "application/json",
// 			},
// 		};
// 		const response = await axios.post(`${API_URL}/api/update/signup`, data, config);
// 		return response.data;
// 	} catch (error) {
// 		console.error("Register error:", error);
// 		return error.response?.data || {status: false, message: error.message};
// 	}
// };

export const BusinessVerificationPromptService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/business/verification/check`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const SendEmailChangeOtpService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/email/send-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const VerifyEmailChangeOtpService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/email/verify-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const SendPhoneChangeOtpService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/phone/send-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const VerifyPhoneChangeOtpService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/phone/verify-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const GetBusinessVerifiedService = async () => {
	try {
		const response = await api.get(`${API_URL}/api/get/business-verified`);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};
